import * as Redux from 'redux';
import { SimManagementError } from '../models/Errors';
import { BasicSearchFilter } from '../models/searchFilter';
import {
  CLEAR_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER,
  ENSURE_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER,
  LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER,
  LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_FAILURE,
  LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_PENDING,
  LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_SUCCESS,
} from './actionTypes';
import { Action, ActionMeta } from './commonActions';

/**
 * An action that clears the available commands for the current user, company and account
 */
export function clearUserCommandTypes(): Redux.Action {
  return {
    type: CLEAR_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER,
  };
}

/**
 * Action which loads the available commands
 *  for the current user, company and account from the server.
 * @param payload The serial numbers for the currently selected stock.
 */
export function ensureUserCommandTypes(payload: BasicSearchFilter): Action<BasicSearchFilter> {
  return {
    type: ENSURE_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER,
    payload,
  };
}

/**
 * Action which loads the available command types
 * for the current user, company and account from the server.
 * @param payload The serial numbers for the currently selected stock.
 */
export function loadUserCommandTypes(payload: BasicSearchFilter): Action<BasicSearchFilter> {
  return {
    type: LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER,
    payload,
  };
}

/**
 * Action which sets the load status to pending
 * for the available command types for the current user, company and account.
 * @param payload The serial numbers for the currently selected stock.
 */
export function loadUserCommandTypesPending(payload: BasicSearchFilter): Action<BasicSearchFilter> {
  return {
    type: LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_PENDING,
    payload,
  };
}

/**
 * Action which handles when all available command types
 * for the current user, company and account are successfully loaded.
 * @param meta The filter criteria.
 * @param data A list of available command types.
 */
export function loadUserCommandTypesSuccess(
  meta: BasicSearchFilter,
  data: string[],
): ActionMeta<string[], BasicSearchFilter> {
  return {
    type: LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_SUCCESS,
    payload: data,
    meta,
  };
}

/**
 * Action which handles when there is a failure to load available command types
 * for the current user, company and account.
 * @param meta The filter criteria.
 * @param error The error.
 */
export function loadUserCommandTypesFailure(
  meta: BasicSearchFilter,
  error: SimManagementError,
): ActionMeta<SimManagementError, BasicSearchFilter> {
  return {
    error: true,
    type: LOAD_ALL_AVAILABLE_COMMAND_TYPES_FOR_USER_FAILURE,
    payload: error,
    meta,
  };
}
